module.exports = __webpack_public_path__ + "static/media/back.b896c81a.png";